export default __webpack_public_path__ + "static/media/versus_screen.a121b228.mp4";